import Translate, {__} from './Translate';
export default function MappingRow({ index, notionField, wordPressField, fieldOptions, mappingManager, ...props }) {
	const { removeMappingRow, notionFieldsOptions, wordPressFieldsOptions, updateNotionField, updateWordPressField, updateFieldOption } = mappingManager;
	const notionFieldDisabled = notionFieldsOptions.length === 0; // || loadingDatabasesAndPages;

	const notionFieldChangedHandler = (e) => {
		updateNotionField(index, e.target.value)
	};

	const wordPressFieldChangedHandler = (e) => {
		updateWordPressField(index, e.target.value);
	};

	const customFieldOptionChangedHandler = (e) => {
		updateFieldOption(index, 'name', e.target.value);
	};

	const removeMappingRowHandler = () => {
		removeMappingRow(index)
	};

	const renderCustomFieldOptions = () => {
		return <div className="notionwpsync-field form-required">
			<label htmlFor="customfield[]">
				<span>{ __('Custom Field', 'wp-sync-for-notion') }</span>
				<span className="notionwpsync-required" aria-hidden="true">*</span>
				<span className="screen-reader-text">{ __(' (required)', 'wp-sync-for-notion') }</span>
			</label>
			<input value={ fieldOptions.name ?? '' } type="text" name="customfield[]" className="regular-text ltr" onChange={ customFieldOptionChangedHandler } />
		</div>;
	};

	return <tr { ...props }>
		<td>
			<div className="notionwpsync-field form-required">
				<label>
					<span>{ __('Notion Field', 'wp-sync-for-notion') }</span>
					<span className="notionwpsync-required" aria-hidden="true">*</span>
					<span className="screen-reader-text">{ __(' (required)', 'wp-sync-for-notion') }</span>
				</label>
				<select name="notion[]"  className="regular-text ltr" value={ notionField } disabled={ notionFieldDisabled } onChange={ notionFieldChangedHandler }>
					{
						Object.keys(notionFieldsOptions).map((groupKey) => {
							const group = notionFieldsOptions[groupKey];
							return <optgroup key={ group.label } label={ group.label }>
								{
									group.options.map((f) => {
										return <option key={ f.id } value={ f.id }>{ f.name }</option>
									})
								}
							</optgroup>;
						})
					}
				</select>
			</div>
		</td>
		<td>
		<div className="notionwpsync-field form-required">
			<label>
				<span>{ __('Import As', 'wp-sync-for-notion') }</span>
				<span className="notionwpsync-required" aria-hidden="true">*</span>
				<span className="screen-reader-text">{ __(' (required)', 'wp-sync-for-notion') }</span>
			</label>
			<select name="wordpress[]" className="regular-text ltr" value={ wordPressField } onChange={ wordPressFieldChangedHandler }>
				<option value=""></option>
				{
					Object.keys(wordPressFieldsOptions[index]).map((groupKey) => {
						const group = wordPressFieldsOptions[index][groupKey];
						return <optgroup key={ group.label } label={ group.label }>
							{
								group.options.map((option) => {
									return <option key={ option.value } value={ option.value } disabled={ !option.enabled }>{ option.label }</option>
								})
							}
						</optgroup>;
					})
				}
			</select>
		</div>
		{ wordPressField === 'meta::custom_field' ? renderCustomFieldOptions() : null }
	</td>
	<td className="col-actions">
		<button type="button" className="btn btn-remove" onClick={ removeMappingRowHandler }>
		<span className="btn-remove-close-icon" aria-hidden="true">&times;</span>
		<span className="screen-reader-text">{ __('Remove', 'wp-sync-for-notion') }</span>
	</button>
</td>
</tr>;
}
